module.exports = __webpack_public_path__ + "static/media/01.6a7650a2.jpg";